var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect } from 'react';
import Button from '@storeblocks/button';
import { getText, getCurrentLanguage, } from '@storebrand-digital/fms-translations';
import { ButtonWrap, FooterButtonWrap, Wrap } from './styled';
import { useModalContext } from '../../../../components/Context';
function Categories(_a) {
    var remaining = _a.remaining, levels = _a.levels, dataTrackId = _a.dataTrackId, setLevels = _a.setLevels, onBackClick = _a.onBackClick;
    var language = getCurrentLanguage();
    var _b = useModalContext(), setHeading = _b.setHeading, setFooter = _b.setFooter;
    function onCategoryClick(name, label, fscPayload, trackId) {
        setLevels(__spreadArray(__spreadArray([], levels, true), [
            {
                name: name,
                label: label,
                fscPayload: fscPayload,
                trackId: trackId,
            },
        ], false));
    }
    useEffect(function () {
        setHeading(getText('compose.heading'));
        setFooter(levels.length > 0 && onBackClick !== undefined && (React.createElement(FooterButtonWrap, null,
            React.createElement(Button, { variant: "outlined", onClick: onBackClick, "data-trackid": "button-".concat(dataTrackId, "_back|").concat(getText('compose.categories.back.label')) }, getText('compose.categories.back.label')))));
    }, [setFooter, getText, levels, onBackClick]);
    return (React.createElement(Wrap, null,
        React.createElement(ButtonWrap, null, remaining.map(function (_a) {
            var name = _a.name, label = _a.label, fscPayload = _a.fscPayload, trackId = _a.trackId;
            return (React.createElement(Button, { key: name, value: name, "data-trackid": "button-".concat(trackId, "|").concat(label.no), onClick: function () { return onCategoryClick(name, label, fscPayload, trackId); }, "data-hj-allow": true }, label[language === 'nb' ? 'no' : language]));
        }))));
}
export default Categories;
